import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import {
  Row,
  Column,
  Container,
  Loader,
  ActionBar,
  DetailsItem,
  withApi,
  withUser,
  withBrowser,
  withNotifier,
  apiShape,
  browserShape,
  notifierShape,
  ForbiddenError,
  sortBy,
} from "lcm-iot-commons";

import AssignableUserList from "lcm-iot-commons/client/lib/components/Users/AssignableUserList";
import { capitalize } from "lodash-es";

type Props = {
  api: apiShape;
  browser: browserShape;
  notifier: notifierShape;
};

export function UserRoleDetails(props: Props) {
  const { api, browser, notifier } = props;
  const [userRole, setUserrole] = useState();
  const [users, setUsers] = useState();

  const loadData = async () => {
    try {
      const filter = { name: "reseller" };
      const response = await api.get("/userroles", filter);
      const role = response.userroles[0];
      setUserrole(role);

      const sortedUsers = await api.getAll(`/userroles/${role.id}/users`, {
        order_by: "last_name",
      });
      setUsers(sortedUsers.users);
    } catch (error) {
      if (error instanceof ForbiddenError) {
        browser.navigateTo("/404");
      } else {
        notifier.showError(api.translateError(error));
      }
    }
  };
  React.useEffect(() => {
    loadData();
  }, []);

  const assignUser = async (user: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    await api.post(`/userroles/${userRole.id}/users`, {
      users: [{ id: user.id }],
    });
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    setUsers(sortBy(users.concat([{ ...{ ...user } }]), "first_name"));
  };

  const unassignUser = async (user: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    await api.delete(`/userroles/${userRole.id}/users`, {
      users: [{ id: user.id }],
    });
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    setUsers(users.filter((u: $TSFixMe) => u.id !== user.id));
  };

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <h1 id="details-header">
              <FormattedMessage id="user_role_details.header" />
            </h1>
          </ActionBar>
          {userRole && (
            <>
              <DetailsItem
                id="user-role-name"
                translationKey="label.name"
                value={capitalize((userRole as $TSFixMe).name)}
              />
              <DetailsItem
                id="user-role-description"
                translationKey="label.description"
                value={(userRole as $TSFixMe).description}
              />
            </>
          )}
          {users && (
            <div id="user-list">
              <h2>
                <FormattedMessage
                  id="user_role_details.users"
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  values={{ role: userRole.name }}
                />
              </h2>
              <AssignableUserList
                // @ts-expect-error TS(2322) FIXME: Type '{ showUserEmail: true; users: never; canUpda... Remove this comment to see the full error message
                showUserEmail
                users={users}
                canUpdate
                onAssignUser={assignUser}
                onUnassignUser={unassignUser}
              />
            </div>
          )}
          <Loader id="user-role-loader" loading={!userRole || !users} />
        </Column>
      </Row>
    </Container>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<Props, "... Remove this comment to see the full error message
export default withApi(withNotifier(withUser(withBrowser(UserRoleDetails))));
